export const serverNow = (clock) => clock.current.server + performance.now() - clock.current.local;
const plural = new Intl.PluralRules('ru');
export const teamCount = (count) => `${count} ${{ one: 'команда', few: 'команды', many: 'команд', other: 'команды' }[plural.select(count)]}`;

export function wheelMoment(wheel, now) {
  if (!wheel?.steps?.length || wheel.status === 'stopped') return { phase: 'idle', active: false, index: -1 };
  const period = wheel.spinMs + wheel.holdMs;
  const index = Math.min(Math.max(0, Math.floor((now - wheel.startsAt) / period)), wheel.applied, wheel.steps.length - 1);
  const startsAt = wheel.startsAt + index * period;
  const endsAt = startsAt + wheel.spinMs;
  const applied = wheel.applied > index;
  const settled = wheel.status === 'finished' && now >= endsAt + wheel.holdMs;
  const phase = settled ? 'idle' : now < startsAt ? 'ready' : now < endsAt ? 'spinning' : applied ? 'result' : 'confirming';
  const used = new Set(wheel.steps.slice(0, index).map((step) => step.team));
  return { index, startsAt, endsAt, phase, applied, active: !settled,
    step: wheel.steps[index], teams: wheel.teams.filter((name) => !used.has(name)) };
}

export function wheelRotation(teams, selected) {
  const index = teams.indexOf(selected);
  return 6 * 360 + (360 - Math.max(0, index) * 360 / teams.length) % 360;
}

export function wheelSlice(index, count, radius = 224, inner = 68) {
  const point = (r, degrees) => `${260 + r * Math.cos(degrees * Math.PI / 180)},${260 + r * Math.sin(degrees * Math.PI / 180)}`;
  if (count === 1) return `M260,${260 - radius} A${radius},${radius} 0 1 1 260,${260 + radius} A${radius},${radius} 0 1 1 260,${260 - radius} M260,${260 - inner} A${inner},${inner} 0 1 0 260,${260 + inner} A${inner},${inner} 0 1 0 260,${260 - inner}`;
  const start = -90 + (index - .5) * 360 / count, end = start + 360 / count;
  return `M${point(inner, start)} L${point(radius, start)} A${radius},${radius} 0 ${count < 2 ? 1 : 0} 1 ${point(radius, end)} L${point(inner, end)} A${inner},${inner} 0 0 0 ${point(inner, start)} Z`;
}
